import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { CalendarCheck, CheckCircle2, Clock, Star } from 'lucide-react';
import TeacherSessionCard from '../../components/teacher/TeacherSessionCard';
import { useTeacherSessions } from '../../hooks/useTeacherSessions';

const Stat = ({ icon: Icon, label, value, testId }) => (
  <div className="rounded-2xl bg-white shadow-md p-5" data-testid={testId}>
    <Icon className="w-5 h-5 text-violet-600 mb-3" />
    <p className="text-3xl font-bold text-slate-900">{value}</p>
    <p className="text-sm text-slate-500">{label}</p>
  </div>
);

const TeacherHome = () => {
  const { profile } = useOutletContext();
  const sessions = useTeacherSessions('upcoming');
  const st = profile.stats || {};

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-testid="teacher-home-page">
      <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-2">Hello, {profile.name.split(' ')[0]}</h1>
      <p className="text-base md:text-lg text-slate-600 mb-8">Your booked and upcoming sessions, with meeting links from your executive.</p>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
        <Stat icon={CalendarCheck} label="Upcoming sessions" value={st.upcoming ?? 0} testId="teacher-stat-upcoming" />
        <Stat icon={CheckCircle2} label="Completed sessions" value={st.completed ?? 0} testId="teacher-stat-completed" />
        <Stat icon={Clock} label="Hours taught" value={st.hours_taught ?? 0} testId="teacher-stat-hours" />
        <Stat icon={Star} label={`Rating (${st.total_ratings ?? 0} reviews)`} value={(st.rating || 0).toFixed(1)} testId="teacher-stat-rating" />
      </div>

      <h2 className="text-lg font-bold text-slate-900 mb-4">Upcoming sessions</h2>
      {sessions === null ? (
        <p className="text-slate-500">Loading...</p>
      ) : sessions.length === 0 ? (
        <div className="py-14 text-center rounded-2xl border border-dashed border-slate-300 bg-white text-slate-500" data-testid="teacher-no-upcoming">
          No upcoming sessions yet. Add availability so students can book you.
        </div>
      ) : (
        <div className="space-y-3">{sessions.map((s) => <TeacherSessionCard key={s.id} s={s} />)}</div>
      )}
    </div>
  );
};

export default TeacherHome;
